export enum EnvType {
  MSDK_V3 = 'msdk_v3',
  MSDK_V5 = 'msdk_v5',
  ItemSDK = 'itemsdk',
  JKMicro = 'jkmicro', // 集客开放平台微应用
  OutGame = 'outgame',
}

// 分享渠道：朋友圈/微信好友/qq好友/QQ空间
export type ChannelID = 'wxt' | 'wxf' | 'qqf' | 'qqz';

export interface SendToOptions {
  // 仅 TGMobileShare (outgame) 可以不填
  channelID?: ChannelID
  // only for TGMobileShare (outgame)
  actName?: string

  url?: string
  title?: string
  desc?: string
  // TODO: 记得处理以 https 开头
  imgUrl?: string
  imgData?: string
}

export interface Adapter {
  init(): Promise<void>
  sendTo(config: any, opts: SendToOptions): Promise<void>
}
